import React from 'react';
import {NodeModel} from '@minoru/react-dnd-treeview';
import {Button, Icon, Row, Space, Tag} from '@mc/ui-v4';
import {mcLocation, mcNew} from '@mc/react-ui-icons';
import {truncate} from '../../helpers/DataMutators';

type Props = {
    node: NodeModel;
    diskriminatorAtributId: number;
    addItem: (data: NodeModel) => void;
};

export const ExternalNode: React.FC<Props> = props => {
    const {text} = props.node;
    const {addItem, node, diskriminatorAtributId} = props;
    const isDiscriminator = node.id && diskriminatorAtributId && node.id === diskriminatorAtributId;

    const handleDragStart = (e: React.DragEvent) => {
        e.dataTransfer.setData('text', JSON.stringify(props.node));
    };

    return (
        <Row className="align-items-center py-0">
            <Button
                className={'justify-self-end mr-2'}
                style={'link'}
                icon={<Icon icon={mcNew} />}
                onClick={() => {
                    addItem(node);
                }}
            />
            <div draggable onDragStart={handleDragStart}>
                <Space>
                    <Tag color={'blue'} title={text}>
                        {truncate(text, 52)}
                    </Tag>
                    {isDiscriminator && <Icon title={'Atribut je diskriminátorem vrstvy'} icon={mcLocation} />}
                </Space>
            </div>
        </Row>
    );
};
